/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 19:00:02
 */
import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * companyInterface
   * @description api商户列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  companyInterface(data) {
    return request.get(`${BASE_URL}/company/company_interface`, data)
  },

   /**
   * @description 获取开放平台分类信息
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getOpenapiCategoryList() {
    return request.get(`${BASE_URL}/openapi/category_list`)
  },
  
  // 支付宝授权
  postAlipayRecharge(id,data) {
    return request.put(`${BASE_URL}/company/alipay_recharge/${id}`, data)
  },
  //定制-api商户设置绿城供应商配置
  postSet_lc_supplier(data) {
    return request.post(`/paas/company/set_lc_supplier`, data)
  },
}